export const NAV_TAB_IDS = ['home', 'market', 'lounge', 'me'];
export const NAV_TABS_PREFIX = 'tabs';
const TAB_LABELS = {
    home: '홈',
    market: '마켓',
    lounge: '커뮤니티(라운지)',
    me: '마이페이지',
};
export const NAV_TABS_FIELDS = [
    {
        key: 'tabs.order',
        label: '하단 탭 순서',
        help: '하단 탭 네 개의 순서. 가운데 + 버튼은 두 번째와 세 번째 탭 사이에 그대로 있다. 숨긴 탭은 순서에서 빠진다.',
        type: 'order',
        defaultValue: [...NAV_TAB_IDS],
        items: NAV_TAB_IDS.map((id) => ({ value: id, label: TAB_LABELS[id] })),
    },
    {
        key: 'tabs.market.visible',
        label: '마켓 탭 보이기',
        help: '끄면 하단 탭에서 마켓이 빠진다. 마켓 화면은 홈의 마켓 더보기·링크로 계속 열 수 있다.',
        type: 'boolean',
        defaultValue: true,
    },
    {
        key: 'tabs.lounge.visible',
        label: '커뮤니티 탭 보이기',
        help: '끄면 하단 탭에서 커뮤니티(라운지)가 빠진다. 화면은 링크로 계속 열 수 있다.',
        type: 'boolean',
        defaultValue: true,
    },
    {
        key: 'tabs.add.visible',
        label: '가운데 + 버튼 보이기',
        help: '끄면 하단 가운데 + 버튼(방송·상품 등록)이 빠진다. 딜러의 등록 화면은 마이페이지에서 계속 열 수 있다.',
        type: 'boolean',
        defaultValue: true,
    },
];
const ALIAS = /^[\da-z][\da-z-]{0,39}$/;
const APP_PATH = /^\/[\w%&./=?[\]-]*$/;
const APP_PATH_MAX_LENGTH = 300;
export const NAV_ALIASES_MAX_ENTRIES = 200;
const isTree = (value) => typeof value === 'object' && value !== null && !Array.isArray(value);
const isAppPath = (value) => typeof value === 'string' &&
    value.length <= APP_PATH_MAX_LENGTH &&
    APP_PATH.test(value) &&
    !value.startsWith('//');
export function validateNavAliasesPayload(payload) {
    if (!isTree(payload))
        return { ok: false, errors: ['nav.aliases: must be an object'] };
    const errors = [];
    const aliases = {};
    const entries = Object.entries(payload);
    if (entries.length > NAV_ALIASES_MAX_ENTRIES)
        errors.push(`nav.aliases: at most ${NAV_ALIASES_MAX_ENTRIES} aliases`);
    for (const [alias, path] of entries) {
        if (!ALIAS.test(alias))
            errors.push(`${alias}: lowercase letters, digits and - (up to 40)`);
        else if (!isAppPath(path))
            errors.push(`${alias}: must be an app path starting with /`);
        else
            aliases[alias] = path;
    }
    return errors.length ? { ok: false, errors } : { ok: true, payload: aliases, errors };
}
export function mergeNavAliasesPayload(_builtIn, received) {
    if (!isTree(received))
        return null;
    const aliases = {};
    for (const [alias, path] of Object.entries(received))
        if (ALIAS.test(alias) && isAppPath(path))
            aliases[alias] = path;
    return aliases;
}
export function parseNavAliasPath(path) {
    const match = /^\/go\/([\da-z][\da-z-]{0,39})\/?$/.exec(path);
    return match?.[1] ?? null;
}
//# sourceMappingURL=nav.js.map